import type { Duration, Onset } from './units/UnitValue';

export class Cell {
  duration: Duration;

  onset: Onset;

  constructor(duration: Duration | number, onset:Onset | number) {
    this.duration = duration as Duration;
    this.onset = onset as Onset;
  }
}

export class Line {
  cells: Cell[];

  constructor(cells: Cell[]) {
    this.cells = cells;
  }

  getDuration(): Duration {
    return this.cells
      .map((cell) => cell.duration)
      .reduce((previous, current) => (previous + current) as Duration);
  }
}

export class Block {
  lines: Line[];

  constructor(lines: Line[]) {
    this.lines = lines;
  }
}
